//@flow
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import config from '../../config';
import SelectCountry from './SelectCountry';
import { setTravelCountry } from '../../modules/International/Travel';
import { getTravelZoneCountries } from '../../lib/country-utils';

import type { DispatchProps, StateProps } from './SelectCountry';
import type { StateType } from '../../modules/reducers';
import Navigation from '../../lib/navigation';

const initialCountries = getTravelZoneCountries(config.iddCountries);

const mapStateToProps = (state: StateType): StateProps => ({
  initialCountries,
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  selectCountry: country => {
    dispatch(setTravelCountry(country));
    !!country.iddZone
      ? Navigation.dispatch(CommonActions.navigate({ name: 'travelTopUp' }))
      : Navigation.dispatch(CommonActions.navigate({ name: 'noInternationalOffer' }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCountry);
